import { findComponentDownward } from 'view-design/src/utils/assist';
import { IS_PRODUCTION } from '@shared/helpers/env';

const ZFormComponent = 'ZForm';
function isComponent(component) {
  try {
    return '_componentTag' in component.$options;
  } catch (e) {
    return false;
  }
}

function isFormComponent(component) {
  if (isComponent(component)) {
    try {
      const { name } = component.$options;
      return name === ZFormComponent;
    } catch (e) {
      return false;
    }
  }

  return false;
}

export const PageServerValidationResponseMixin = {
  methods: {
    _get_form_component: function(config) {
      let link_to_component;

      const { form } = config;

      if (isComponent(form)) {
        link_to_component = form;
      } else if (this.$refs.form) {
        link_to_component = this.$refs.form;
      }

      if (isComponent(link_to_component)) {
        return isFormComponent(link_to_component)
          ? link_to_component
          : findComponentDownward(link_to_component, ZFormComponent);
      }
    },

    _catch_validation_error: function(error, config) {
      const $form = this._get_form_component(config);

      if ($form) {
        const fields = $form.getFields();
        const errors = error.getValidationErrorMessages(fields);
        $form.setErrors(errors);
      } else {
        /**
         * Перестраховка. Отображаем сообщение с бекенда
         */
        const errors = error.getValidationErrors();
        const first_key = Object.keys(errors)[0];
        const first_error = errors[first_key][0].message_fallback;

        if (IS_PRODUCTION) {
          this.$noty.error(first_error);
        } else {
          alert(`Непредусмотренная ошибка валидации. Ключ: ${first_key}`);
          this.$noty.error(first_error);
        }
      }
    },

    _catch_other_error: function(error) {
      this.$noty.server_error(error);
    },

    check_server_validation: function(error, config = {}) {
      if (error.isValidationError()) {
        return this._catch_validation_error(error, config);
      } else {
        return this._catch_other_error(error);
      }
    }
  }
};
